import {
  Accordion,
  accordionSummaryClasses,
  alpha,
  Box,
  Paper,
  styled,
  Typography,
} from "@mui/material";

export const StyledRendererContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const StyledStepAccordion = styled(Accordion)({
  "&:before": {
    display: "none",
  },
});

export const StyledErrorAccordion = styled(StyledStepAccordion)(
  ({ theme }) => ({
    [`& .${accordionSummaryClasses.root}`]: {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.error.main,
      },
      // Règle ajoutée pour forcer la couleur du texte
      "& .MuiTypography-root": {
        color: theme.palette.error.contrastText,
      },
    },
    [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
      color: theme.palette.error.contrastText,
    },
  }),
);

export const StyledSectionContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const StyledFieldPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "isError",
})<{ isError?: boolean }>(({ theme, isError }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  overflow: "hidden",
  ...(isError && {
    borderColor: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.main, 0.05),
    "& h5": {
      color: theme.palette.error.dark,
    },
  }),
}));

export const StyledFieldTypography = styled(Typography)({
  display: "block",
  wordBreak: "break-all",
});

export const StyledChipContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: "flex",
  gap: theme.spacing(1),
  flexWrap: "wrap",
}));

export const StyledPlaceholder = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
